import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { BellRing, Check, Loader2 } from "lucide-react";
import { errMsg, http } from "@/lib/api";
import { usePageTitle } from "@/lib/hooks";

export default function ConfirmAlertsPage() {
  usePageTitle("Confirm alerts");
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ busy: false, brands: null, error: "" });

  // Confirmation needs a tap, so email link scanners can't switch alerts on by themselves.
  const confirm = async () => {
    setState({ busy: true, brands: null, error: "" });
    try {
      const { data } = await http.post(`/alerts/confirm?token=${encodeURIComponent(token)}`);
      setState({ busy: false, brands: data?.brands ?? [], error: "" });
    } catch (e) {
      setState({ busy: false, brands: null, error: errMsg(e) });
    }
  };

  const done = Array.isArray(state.brands);
  return (
    <section className="mx-auto flex min-h-[80svh] max-w-xl flex-col items-center justify-center px-5 pb-24 pt-36 text-center" data-testid="confirm-alerts-page">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-ph-lime/15 text-ph-accent">{done ? <Check className="h-7 w-7" /> : <BellRing className="h-7 w-7" />}</span>
      <h1 className="mt-6 font-display text-4xl font-extrabold tracking-tight text-ph-ink" data-testid="confirm-alerts-title">
        {done ? "Alerts confirmed" : state.error ? "Link not valid" : "Confirm your price-list alerts"}
      </h1>
      <p className="mt-3 text-ph-muted" data-testid="confirm-alerts-message">
        {done ? `You'll get an email when ${state.brands.join(", ") || "these brands"} publish or update a price list. Every alert has an unsubscribe link.`
          : state.error || "Tap the button to start receiving alert emails for the brands you chose."}
      </p>
      {!done && !state.error && (
        <button type="button" onClick={confirm} disabled={state.busy || !token} data-testid="confirm-alerts-btn"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-ph-lime px-7 py-3.5 text-sm font-semibold text-ph-navy disabled:opacity-60">
          {state.busy && <Loader2 className="h-4 w-4 animate-spin" />} Confirm my alerts
        </button>
      )}
      <Link to="/" className="mt-6 text-sm font-semibold text-ph-accent hover:underline" data-testid="confirm-alerts-home">Back to PRICEHUB</Link>
    </section>
  );
}
